<template>
  <div>
    <search-page
      v-if="search"
      v-bind="search"
      data-ui="search-page"
    >
      <template #filterMenu="filterMenuProps">
        <filter-menu-component
          v-bind="filterMenuProps"
          :date-picker="datePicker"
          :location-facet="location"
          :collapsable-link-list="collapsableLinkList"
        />
      </template>
      <CourseSkeletonGridComponent v-if="isLoading"></CourseSkeletonGridComponent>
      <template v-else>
        <course-grid-component
          v-if="!!results.length"
          :courses="results"
          data-ui="course-grid"
        />
        <no-results
          v-else
          v-bind="noResults"
        />
      </template>
    </search-page>
  </div>
</template>

<script>
import { SearchPage } from '@rei/search-page';
import CourseGridComponent from './CourseGridComponent.vue';
import FilterMenuComponent from './FilterMenuComponent.vue';
import NoResults from './NoResultsPageComponent.vue';
import CourseSkeletonGridComponent from './CourseSkeletonGridComponent.vue';

export default {
  name: 'ResultPageComponent',
  components: {
    CourseGridComponent,
    FilterMenuComponent,
    SearchPage,
    NoResults,
    CourseSkeletonGridComponent,
  },
  props: {
    search: {
      type: Object,
      required: false,
      default: null,
    },
    results: {
      type: Array,
      required: true,
    },
    noResults: {
      type: Object,
      required: true,
    },
    datePicker: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    collapsableLinkList: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
